import { Component, computed, Inject, Input, signal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation, faXmark, faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../core/services/alert.service'; 
//import { BtnComponent } from '../btn.component/btn.component';

@Component({
  selector: 'app-alert',
  imports: [FontAwesomeModule, CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  faSuccess = faCheckDouble; 
  faError = faXmark; 
  faWarning = faTriangleExclamation
  
  faDefault = faCheckDouble; 

  s_alert = Inject(AlertService).alert;  

  constructor(private _svc_alert:AlertService) 
  {
    this.s_alert = this._svc_alert.alert;
  }

}
